// extracted by mini-css-extract-plugin
module.exports = {"container":"views-LivestreamEventBody__container--tkqTf","inlineVideo":"views-LivestreamEventBody__inlineVideo--390I0"};